import { FormattedMessage } from 'components/shared/Intl';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import { FC } from 'react';
import { Modal, ModalBody } from 'react-bootstrap';

import { WorkflowErrorDetailsList } from './WorkflowErrorDetailsList';

export interface WorkflowErrorDetailsModalProps {
  errors: readonly NextWorkflowError[];
  isOpen: boolean;
  shouldDisplayErrorDetails?: boolean;
  toggle: () => void;
  useLegacyWorkFlowError?: boolean;
}

export const WorkflowErrorDetailsModal: FC<WorkflowErrorDetailsModalProps> = ({
  errors,
  isOpen,
  shouldDisplayErrorDetails = false,
  toggle,
  useLegacyWorkFlowError = false,
}) => {
  return (
    <Modal show={isOpen} onHide={toggle} centered data-e2e="workflow-error-details-modal">
      <div className="modal-header pb-3 justify-content-between">
        <h3 className="modal-title">
          <FormattedMessage id="errorDetails" />
          <span className="badge rounded-pill badge-discreet-primary badge-sm align-middle ms-2">{errors.length}</span>
        </h3>

        <button
          aria-label="Close"
          className="btn  btn-flat-secondary"
          data-dismiss="modal"
          data-e2e="error-details-close-button"
          onClick={toggle}
          type="button"
        >
          <em className="icon">close</em>
        </button>
      </div>
      <ModalBody>
        <WorkflowErrorDetailsList
          shouldDisplayErrorDetails={shouldDisplayErrorDetails}
          useLegacyWorkFlowError={useLegacyWorkFlowError}
          useMaxHeight
          workflowErrors={errors}
        />
      </ModalBody>
    </Modal>
  );
};
